import { render } from "./AgreementSet.vue?vue&type=template&id=45f872aa&scoped=true"
import script from "./AgreementSet.vue?vue&type=script&lang=js"
export * from "./AgreementSet.vue?vue&type=script&lang=js"

import "./AgreementSet.vue?vue&type=style&index=0&id=45f872aa&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f872aa"]])

export default __exports__